import axios from "axios";
import { Dispatch } from "redux";
import Url from "../../Url";
import { getHealthcampListAction } from "./Actions";
import {
  AdminGetHealthcampListActionTypes,
  HEALTHCAMP_LIST_FAIL,
  HEALTHCAMP_LIST_LOADING,
  HEALTHCAMP_LIST_SUCCESS,
} from "./ActionTypes";
import { headers } from "components/Utility";

export const getHealthcampListValue = () => {
  return function (dispatch: Dispatch<AdminGetHealthcampListActionTypes>) {
    dispatch({
      type: HEALTHCAMP_LIST_LOADING,
    });
    axios
      .get(Url.apiURL + "/caregiverapp/api/healthcamp/heathcamp_list_where_as_owner", {
        headers: headers,
      })
      .then((res) => {
        let healthcampData = res.data;
        dispatch(getHealthcampListAction(healthcampData));
        dispatch({
          type: HEALTHCAMP_LIST_SUCCESS,
          payload: healthcampData,
        });
      })
      .catch((_error) => {
        dispatch({
          type: HEALTHCAMP_LIST_FAIL,
        });
      });
  };
};
